import React, { useState, useEffect, useRef } from 'react';
import { CalendarIcon } from 'lucide-react';
const DEFAULT_TIME_FILTER_OPTIONS = [
    { key: '7', text: 'Last 7 days', value: 7 },
    { key: '30', text: 'Last 30 days', value: 30 },
    { key: '90', text: 'Last 90 days', value: 90 },
    { key: '365', text: 'Last year', value: 365 }
];
export const TimeSelector = ({ selectedDays, options = DEFAULT_TIME_FILTER_OPTIONS, onChange, className = '' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    // Handle clicks outside dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const handleOptionSelect = (value) => {
        onChange(value);
        setIsOpen(false);
    };
    return (React.createElement("div", { className: `relative ${className}`, ref: dropdownRef },
        React.createElement("button", { className: "inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500", onClick: () => setIsOpen(!isOpen) },
            React.createElement(CalendarIcon, { className: "w-4 h-4 mr-2" }),
            "Last ",
            selectedDays,
            " days",
            React.createElement("svg", { className: "w-4 h-4 ml-2", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" },
                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }))),
        isOpen && (React.createElement("div", { className: "absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10 border border-gray-200" },
            React.createElement("div", { className: "py-1" }, options.map(option => (React.createElement("button", { key: option.key, className: `block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${selectedDays === option.value ? 'bg-gray-50 text-gray-900' : 'text-gray-700'}`, onClick: () => handleOptionSelect(option.value) }, option.text))))))));
};
export default TimeSelector;
